import { render, staticRenderFns } from "./AuthorsCard.vue?vue&type=template&id=b0bc26f0&scoped=true"
import script from "./AuthorsCard.vue?vue&type=script&lang=js"
export * from "./AuthorsCard.vue?vue&type=script&lang=js"
import style0 from "./AuthorsCard.vue?vue&type=style&index=0&id=b0bc26f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bc26f0",
  null
  
)

export default component.exports